import React from 'react'

export const SEARCH_BAR_ICONS = {
  location: {
    path: 'M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z M15 11a3 3 0 11-6 0 3 3 0 016 0z'
  },
  close: {
    path: 'M6 18L18 6M6 6l12 12'
  },
  search: {
    path: 'M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
  },
  selfStorage: {
    path: 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4'
  },
  chevronDown: {
    path: 'M19 9l-7 7-7-7'
  }
} as const

export const SVG_ICONS = {
  location: React.createElement(
    'svg',
    {
      className: 'size-5',
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24'
    },
    React.createElement('path', {
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: 1.5,
      d: 'M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z'
    }),
    React.createElement('path', {
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: 1.5,
      d: 'M15 11a3 3 0 11-6 0 3 3 0 016 0z'
    })
  ),
  close: React.createElement(
    'svg',
    {
      className: 'size-4',
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24'
    },
    React.createElement('path', {
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: 2,
      d: 'M6 18L18 6M6 6l12 12'
    })
  ),
  search: React.createElement(
    'svg',
    {
      className: 'size-6',
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24'
    },
    React.createElement('path', {
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: 2.5,
      d: 'M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
    })
  ),
  selfStorage: React.createElement(
    'svg',
    {
      className: 'size-4',
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24'
    },
    React.createElement('path', {
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: 2,
      d: 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4'
    })
  ),
  chevronDown: React.createElement(
    'svg',
    {
      className: 'size-5 text-grey-700',
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24'
    },
    React.createElement('path', {
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: 2,
      d: 'M19 9l-7 7-7-7'
    })
  )
} as const
